import { computeCtrPercent } from "./organicSearchReport"
import {
  filterSocialPerformancePlatformsByKeys,
} from "./socialPerformanceReport"

function findChartEntryForSeoTrend(platforms, options = {}) {
  const list = Array.isArray(platforms) ? platforms : []
  const filter = options.platformKeysFilter
  if (filter?.length) {
    const filtered = filterSocialPerformancePlatformsByKeys(
      list,
      filter,
      options.socialNetworkTypes,
    )
    return filtered[0] ?? null
  }
  return findAllPlatformsChartEntry(list)
}

/** ISO date param for GET …/chart/performance?startDate=&endDate= */
export function formatChartPerformanceDate(date) {
  const d = date instanceof Date ? date : new Date(date)
  if (Number.isNaN(d.getTime())) return ""
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, "0")
  const day = String(d.getDate()).padStart(2, "0")
  return `${y}-${m}-${day}`
}

export function buildChartPerformanceFetchKey(clientId, startDate, endDate) {
  return `${String(clientId ?? "")}|${startDate ?? ""}|${endDate ?? ""}`
}

export function unwrapChartPerformancePlatforms(data) {
  if (Array.isArray(data?.data)) return data.data
  if (Array.isArray(data?.platforms)) return data.platforms
  if (Array.isArray(data)) return data
  return []
}

/** All Platforms aggregate (`social_network_type_id: 0`). */
export function findAllPlatformsChartEntry(platforms) {
  const list = Array.isArray(platforms) ? platforms : []
  return (
    list.find(
      (entry) =>
        String(entry?.social_network_type_id ?? entry?.socialNetworkTypeId ?? "") === "0",
    ) ?? null
  )
}

function parseNum(value) {
  if (value == null || value === "") return null
  const numeric = Number(value)
  return Number.isNaN(numeric) ? null : numeric
}

function normalizeTrendPoint(row) {
  const date = row?.date ?? row?.day ?? row?.report_date
  if (!date) return null

  const clicks = parseNum(row?.clicks) ?? 0
  const impressions = parseNum(row?.impressions) ?? 0
  const ctr = parseNum(row?.ctr) ?? 0

  return {
    date: String(date).slice(0, 10),
    clicks,
    impressions,
    ctr,
  }
}

/** Daily series for SEO Trend chart (All Platforms or filtered platform). */
export function buildSeoTrendSeriesFromChartPerformance(data, options = {}) {
  const platforms = unwrapChartPerformancePlatforms(data)
  const entry = findChartEntryForSeoTrend(platforms, options)
  const series = Array.isArray(entry?.series) ? entry.series : []

  return series.map(normalizeTrendPoint).filter(Boolean)
}

/** Period totals for summary cards: sum clicks/impressions; CTR = clicks/impressions × 100. */
export function buildSeoTrendSummaryFromSeries(trendSeries) {
  const series = Array.isArray(trendSeries) ? trendSeries : []
  const totalClicks = series.reduce((sum, row) => sum + (row.clicks ?? 0), 0)
  const totalImpressions = series.reduce((sum, row) => sum + (row.impressions ?? 0), 0)
  const ctr = computeCtrPercent(totalClicks, totalImpressions) ?? 0

  return { clicks: totalClicks, impressions: totalImpressions, ctr }
}

export function normalizeChartPerformancePayload(data) {
  const platforms = unwrapChartPerformancePlatforms(data)
  const trendSeries = buildSeoTrendSeriesFromChartPerformance({ data: platforms })
  return { platforms, trendSeries }
}
